import { SkillSet } from "./interface";

export const skills: SkillSet = {
  specialize: {
    headerEmoji: "🔥",
    headerText: "I specialize in",
    skills: [
      "JavaScript",
      "TypeScript",
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "Airtable",
    ],
  },
  work: {
    headerEmoji: "🛠️",
    headerText: "Working knowledge",
    skills: [
      "Payload CMS",
      "REST APIs",
      "Elixir",
      "Phoenix LiveView",
      "Supabase",
      "Vercel",
      "SQL/PSQL",
    ],
  },
  familiar: {
    headerEmoji: "💡",
    headerText: "Familiar with",
    skills: ["OAuth", "AWS", "Google AI Studio", "MCP servers", "Docker"],
  },
  learn: {
    headerEmoji: "🎓",
    headerText: "Want to learn",
    skills: ["Gatsby", "GraphQL", "Testing", "Node JS", "React Native"],
  },
};
